module.exports = __webpack_public_path__ + "assets/quote_avatar_3.ec5025e8.png";